import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { TabPanel, TabView } from "primereact/tabview";
import React, { useState, useEffect } from "react";
import storage from "../../Services/Storage";
import {
    createAPIEndpointTransferofAdjustedCNandFOC,
    EndpointTransferofAdjustedCNandFOC,
} from "../../Services/TransferofAdjustedCNandFOC/TransferofAdjustedCNandFOCService";
import { toast } from "react-toastify";
import Loader from "../../Components/Loader";

const TransferofAdjustedCNandFOC = () => {
    const auth = storage.getLocal("user");
    const [creditNoteData, setCreditNoteData] = useState();
    const [FOCData, setFOCData] = useState();
    const [debitNoteData, setdebitNoteData] = useState();
    const [tabIndex, setTabIndex] = useState(0);
    const [selectFOCData, setSelectFOCData] = useState([]);
    const [selectCreditNoteData, setSelectCreditNoteData] = useState([]);
    const [selectDebitNoteData, setSelectDebitNoteData] = useState([]);
    const [selectSaveFOCData, setSelectSaveFOCData] = useState([]);
    const [selectSaveDebitNoteData, setSelectSaveDebitNoteData] = useState([]);
    const [selectSaveCreditNoteData, setSelectSaveCreditNoteData] = useState([]);
    const [loader,setLoader] = useState(false);

    const getCreditNoteData = async () => {
        setLoader(true);
        try {
            const response = await createAPIEndpointTransferofAdjustedCNandFOC().get(
                `${EndpointTransferofAdjustedCNandFOC.GetAllTransferCnFoc}?CompId=${auth.CompId}&strUserId=${auth.UserId}&RptType=C`
            );
            setCreditNoteData(response.data.Data);
            setLoader(false);
        } catch (err) {
            console.log("error ", err);
            setLoader(false);
        }
    };
    const getFOCData = async () => {
        setLoader(true);
        try {
            const response = await createAPIEndpointTransferofAdjustedCNandFOC().get(
                `${EndpointTransferofAdjustedCNandFOC.GetAllTransferCnFoc
                }?CompId=${auth.CompId}&strUserId=${auth.UserId}&RptType=F`
            );
            setFOCData(response.data.Data);
            setLoader(false);
        } catch (err) {
            console.log("error ", err);
            setLoader(false);
        }
    };

    const getDebitNoteData = async () => {
        setLoader(true);
        try {
            const response = await createAPIEndpointTransferofAdjustedCNandFOC().get(
                `${EndpointTransferofAdjustedCNandFOC.GetAllTransferCnFoc
                }?CompId=${auth.CompId}&strUserId=${auth.UserId}&RptType=D`
            );
            setdebitNoteData(response.data.Data);
            setLoader(false);
        } catch (err) {
            console.log("error ", err);
            setLoader(false);
        }
    };

    const activeTabIndex = (e) => {
        setTabIndex(e.index);
        handleTabData(e.index);
    };

    const createPayload = () => {
        const data =
            tabIndex == 0
                ? selectSaveCreditNoteData
                : tabIndex == 1
                    ? selectSaveFOCData
                    : selectSaveDebitNoteData;
        const strType = tabIndex == 0 ? "C" : tabIndex == 1 ? "F" : "D";
        return {
            compId: auth.CompId,
            userId: auth.UserId,
            rptType: strType,
            lstCNFoc: data.map((item) => ({
                drcR_HDR_ID: item.DRCR_HDR_ID,
                documenT_NO: item.DOCUMENT_NO,
                documenT_DATE: item.DOCUMENT_DATE,
                partY_ID: item.PARTY_ID,
                partY_NAME: item.PARTY_NAME,
                status: item.STATUS,
                createD_BY: item.CREATED_BY,
                schemE_CODE: item.SCHEME_CODE,
                schM_NAME: item.SCHM_NAME,
                cusT_CODE: item.CUST_CODE,
                cusT_NAME: item.CUST_NAME,
                foC_BALANCE: item.FOC_BALANCE?.toString(),
                freezeD_DATE: item.FREEZED_DATE,
                totaL_AMOUNT: item.TOTAL_AMOUNT?.toString(),
                adjusteD_AMOUNT: item.ADJUSTED_AMOUNT?.toString(),
                acpR_TOT_OUTSTANDING: item.ACPR_TOT_OUTSTANDING?.toString(),
                submiT_STATUS: item.SUBMIT_STATUS,
            })),
        };
    };

    const saveCreditNoteFOCData = async () => {
        setLoader(true);
        let payload = createPayload();
        console.log("data data payload", payload);
        // return;
        await createAPIEndpointTransferofAdjustedCNandFOC()
            .post(`${EndpointTransferofAdjustedCNandFOC.SaveData}`, payload)
            .then((res) => {
                if (res.data.Status == "Success") {
                    toast.success(`${res.data.Message}`, {
                        position: toast.POSITION.TOP_CENTER,
                        pauseOnFocusLoss: false,
                        closeButton: false,
                        autoClose: 2000,
                    });
                } else {
                    if (res.data.Status == "Warning") {
                        console.log("called");
                        toast.warning(`${res.data.Message}`, {
                            position: toast.POSITION.TOP_CENTER,
                            pauseOnFocusLoss: false,
                            closeButton: false,
                            autoClose: 2000,
                        });
                    }
                }
                if(tabIndex==0){
                    getCreditNoteData();
                }
                else if(tabIndex==1){
                    getFOCData();
                }
                // setLoader(false);
            })
            .catch((error) => {
                toast.error("Something Went Wrong.", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 3000,
                });
                console.log("Error ", error);
                setLoader(false);
            });
    };

    const saveDebitNoteData = async () => {
        setLoader(true);
        let payload = createPayload();
        await createAPIEndpointTransferofAdjustedCNandFOC().post(`${EndpointTransferofAdjustedCNandFOC.SaveDebitNote}`, payload)
            .then((res) => {
                if (res.data.Status == "Success") {
                    toast.success(`${res.data.Message}`, {
                        position: toast.POSITION.TOP_CENTER,
                        pauseOnFocusLoss: false,
                        closeButton: false,
                        autoClose: 2000,
                    });
                } else {
                    if (res.data.Status == "Warning") {
                        console.log("called");
                        toast.warning(`${res.data.Message}`, {
                            position: toast.POSITION.TOP_CENTER,
                            pauseOnFocusLoss: false,
                            closeButton: false,
                            autoClose: 2000,
                        });
                    }
                }
                getDebitNoteData();
                setLoader(false);
            })
            .catch((error) => {
                toast.error("Something Went Wrong.", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 3000,
                });
                console.log("Error ", error);
                setLoader(false);
            });

    };

    const onCreditNoteDataSelection = (e) => {
        setSelectCreditNoteData(e.value);
        setSelectSaveCreditNoteData(e.value);
    };

    const onDebitNoteDataSelection = (e) => {
        setSelectDebitNoteData(e.value);
        setSelectSaveDebitNoteData(e.value);
    };

    const onFOCDataSelection = (e) => {
        setSelectFOCData(e.value);
        setSelectSaveFOCData(e.value);
    };

    const handleTabData = (index) => {
        setSelectFOCData([]);
        setSelectDebitNoteData([]);
        setSelectCreditNoteData([]);
        if (index == 0) {
            getDebitNoteData();
        } else if (index == 1) {
            if (FOCData == undefined || FOCData == null) {
                getFOCData();
            }
        } else {
            getDebitNoteData();
        }
    };
    const rowClass = (data) => {
        return {
            "bg-success": data.SUBMIT_STATUS === "Y",
            "bg-danger": data.SUBMIT_STATUS === "N"
        };
    };
    const rowClass1 = (data) => {
        return {
            "bg-success": data.SUBMIT_STATUS === "D",
            "bg-secondary": data.SUBMIT_STATUS === "M"
        };
    };
    useEffect(() => {
        getCreditNoteData();
    }, []);
    if(loader){
        return(<Loader/>);
    }
    else{
        return (
            <div className="col-12 pt-0 pb-4">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <h3 className="mb-3">
                            Transfer of Unadjusted or PartiallyAdjusted CN/FOC
                        </h3>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12"></div>
                </div>
                <div className="TabPanel">
                    <TabView activeIndex={tabIndex} onTabChange={activeTabIndex}>
                        <TabPanel header="Credit Note">
                            <section>
                                <div className="row mb-2">
                                    <div className="col-lg-8 col-md-12 col-sm-12">
                                        <div className="colorBox">
                                            <div className="d-inline-flex align-items-center">
                                                <span className="green item"></span>
                                                <label htmlFor="" className="ml-2">
                                                    Submitted
                                                </label>
                                            </div>
                                            <div className="d-inline-flex align-items-center">
                                                <span className="red item"></span>
                                                <label htmlFor="" className="ml-2">
                                                    Not Submitted
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-12 col-sm-12">
                                        <div className="text-end">
                                            <button
                                                type="button"
                                                className="btn btn-primary"
                                                onClick={saveCreditNoteFOCData}
                                                disabled={selectCreditNoteData?.length===0}
                                            >
                                                Submit
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="DataTable">
                                    <DataTable
                                        value={creditNoteData}
                                        rows={10}
                                        filterDisplay="row"
                                        // showGridlines
                                        stripedRows
                                        scrollHeight="80vh"
                                        scrollable
                                        paginator
                                        selection={selectCreditNoteData}
                                        onSelectionChange={(e) => onCreditNoteDataSelection(e)}
                                        selectionMode="checkbox"
                                        tableStyle={{ minWidth: "80rem" }}
                                        rowClassName={rowClass}
                                    >
                                        <Column
                                            selectionMode="multiple"
                                            header="Select All"
                                            headerStyle={{ width: "5rem" }}
                                        ></Column>
                                        <Column
                                            field="DOCUMENT_NO"
                                            header="Document Number"
                                            filter
                                            filterMatchMode="contains"
                                            filterPlaceholder="Search Here..."
                                        ></Column>
                                        <Column
                                            field="DOCUMENT_DATE"
                                            header="Document Date"
                                            filter
                                            filterMatchMode="contains"
                                            filterPlaceholder="Search Here..."
                                        ></Column>
                                        <Column
                                            field="PARTY"
                                            header="Customer Name"
                                            filter
                                            filterMatchMode="contains"
                                            filterPlaceholder="Search Here..."
                                        ></Column>
                                        <Column
                                            field="SCHEME_CODE"
                                            header="Scheme Code"
                                            filter
                                            filterMatchMode="contains"
                                            filterPlaceholder="Search Here..."
                                        ></Column>
                                        <Column field="TOTAL_AMOUNT" header="Total Amount"></Column>
                                        <Column field="ADJUSTED_AMOUNT" header="Adjusted Amount"></Column>
                                        {/* <Column field="" header="Unadjusted Amount"></Column> */}
                                    </DataTable>
                                </div>
                            </section>
                        </TabPanel>
                        <TabPanel header="FOC">
                            <section>
                                <div className="row mb-2">
                                    <div className="col-lg-8 col-md-12 col-sm-12">
                                        <div className="colorBox">
                                            <div className="d-inline-flex align-items-center">
                                                <span className="green item"></span>
                                                <label htmlFor="" className="ml-2">
                                                    Submitted
                                                </label>
                                            </div>
                                            <div className="d-inline-flex align-items-center">
                                                <span className="red item"></span>
                                                <label htmlFor="" className="ml-2">
                                                    Not Submitted
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-12 col-sm-12">
                                        <div className="text-end">
                                            <button
                                                type="button"
                                                className="btn btn-primary"
                                                onClick={saveCreditNoteFOCData}
                                                disabled={selectFOCData?.length===0}
                                            >
                                                Submit
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="DataTable">
                                    <DataTable
                                        value={FOCData}
                                        rows={10}
                                        filterDisplay="row"
                                        // showGridlines
                                        stripedRows
                                        scrollHeight="80vh"
                                        scrollable
                                        paginator
                                        selection={selectFOCData}
                                        onSelectionChange={(e) => onFOCDataSelection(e)}
                                        selectionMode="checkbox"
                                        tableStyle={{ minWidth: "80rem" }}
                                        rowClassName={rowClass}
                                    >
                                        <Column
                                            selectionMode="multiple"
                                            header="Select All"
                                            headerStyle={{ width: "5rem" }}
                                        ></Column>
                                        <Column
                                            field="PARTY"
                                            header="Name"
                                            filter
                                            filterMatchMode="contains"
                                            filterPlaceholder="Search Here..."
                                        ></Column>
                                        <Column
                                            field="SCHEME_CODE"
                                            header="Scheme Code"
                                            filter
                                            filterMatchMode="contains"
                                            filterPlaceholder="Search Here..."
                                        ></Column>
                                        <Column
                                            field="SCHM_NAME"
                                            header="Scheme Description"
                                            filter
                                            filterMatchMode="contains"
                                            filterPlaceholder="Search Here..."
                                        ></Column>
                                        <Column field="FOC_BALANCE" header="Volume"></Column>
                                        <Column
                                            field="FREEZED_DATE"
                                            header="Freeze Date"
                                            filter
                                            filterMatchMode="contains"
                                            filterPlaceholder="Search Here..."
                                        ></Column>
                                    </DataTable>
                                </div>
                            </section>
                        </TabPanel>
                        <TabPanel header="Debit Note">
                            <section>
                                <div className="row mb-2">
                                    <div className="col-lg-8 col-md-12 col-sm-12">
                                        <div className="colorBox">
                                            <div className="d-inline-flex align-items-center">
                                                <span className="green item"></span>
                                                <label htmlFor="" className="ml-2">
                                                    Debit Note Created
                                                </label>
                                            </div>
                                            <div className="d-inline-flex align-items-center">
                                                <span className="grey item"></span>
                                                <label htmlFor="" className="ml-2">
                                                    Pending for Debit note creation
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-12 col-sm-12">
                                        <div className="text-end">
                                            <button type="button" className="btn btn-primary" disabled={selectDebitNoteData?.length===0} onClick={saveDebitNoteData}>
                                                Create Debit Note
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="DataTable">
                                    <DataTable
                                        value={debitNoteData}
                                        rows={10}
                                        filterDisplay="row"
                                        // showGridlines
                                        stripedRows
                                        scrollHeight="80vh"
                                        scrollable
                                        paginator
                                        selection={selectDebitNoteData}
                                        onSelectionChange={(e) => onDebitNoteDataSelection(e)}
                                        selectionMode="checkbox"
                                        tableStyle={{ minWidth: "80rem" }}
                                        rowClassName={rowClass1}
                                    >
                                        <Column
                                            selectionMode="multiple"
                                            header="Select All"
                                            headerStyle={{ width: "5rem" }}
                                        ></Column>
                                        <Column
                                            field="DOCUMENT_NO"
                                            header="Document Number"
                                            filter
                                            filterMatchMode="contains"
                                            filterPlaceholder="Search Here..."
                                        ></Column>
                                        <Column
                                            field="DOCUMENT_DATE"
                                            header="Document Date"
                                            filter
                                            filterMatchMode="contains"
                                            filterPlaceholder="Search Here..."
                                        ></Column>
                                        <Column
                                            field="PARTY"
                                            header="Customer Name"
                                            filter
                                            filterMatchMode="contains"
                                            filterPlaceholder="Search Here..."
                                        ></Column>
                                        <Column
                                            field="SCHEME_CODE"
                                            header="Scheme Code"
                                            filter
                                            filterMatchMode="contains"
                                            filterPlaceholder="Search Here..."
                                        ></Column>
                                        <Column field="TOTAL_AMOUNT" header="Total Amount"></Column>
                                        <Column field="ADJUSTED_AMOUNT" header="Adjusted Amount"></Column>
                                    </DataTable>
                                </div>
                            </section>
                        </TabPanel>
                    </TabView>
                </div>
            </div>
        );
    }
};

export default TransferofAdjustedCNandFOC;
